import { createStore } from 'vuex' 
import axios from 'axios'

const state = () => {
	return {
		baseUrl: null,
		pageMode: null,
		userToken: null,
		isAuth: false,
		loginUrl: null,
		claimCreditUrl: null,
		isNavMenuVisible: false,
		isCmeInfoModalVisible: false,
		isCmeRegModalVisible: false,
		breakingNews: null,
		logoutFunction: null,
	}
}

const mutations = {
	setBaseUrl(state, value) {
		state.baseUrl = value
	},
	setPageMode(state, value) {
		state.pageMode = value
	},
	setIsAuth(state, value) {
		state.isAuth = value
	},
	setUserToken(state, value) {
		state.userToken = value
	},
	setLoginUrl(state, value) {
		state.loginUrl = value
	},
	setClaimCreditUrl(state, value) {
		state.claimCreditUrl = value
	},
	setIsNavMenuVisible(state, val) {
		state.isNavMenuVisible = val
	},
	setIsCmeInfoModalVisible(state, val) {
		state.isCmeInfoModalVisible = val
	},
	setIsCmeRegModalVisible(state, val) {
		state.isCmeRegModalVisible = val
	},
	setCategories(state, val) {
		state.categories = val
	},
	setBreakingNews(state, val) {
		state.breakingNews = val
	},
	setLogoutFunction(state, val) {
		state.logoutFunction = val
	},
}

const actions = {
	async getCategories({ commit, dispatch }) {
		await axios.get(process.env.VUE_APP_CATEGORIES_URL)
			.then(async ({ data }) => {
				const categories = await dispatch('getCategoryList', {
					arr: data.categories,
				})

				commit('setCategories', categories)
			})
			.catch((err) => { console.log(err) })
	},
	getCategoryList(_, { arr }) {
		let output

		if (arr) {
			const data = arr
				.sort(function(a, b) {
					// Sort by 'featured' property (true comes before false)
					if (a.featured && !b.featured) {
						return -1;
					}
					if (!a.featured && b.featured) {
						return 1;
					}
				
					// Sort alphabetically by another property (e.g., 'categorytitle')
					var nameA = a.categorytitle.toLowerCase();
					var nameB = b.categorytitle.toLowerCase();
					return nameA.localeCompare(nameB);
				})
				.map((cat) => {
					return {
						id: cat.categoryid,
						name: cat.categorytitle,
						shortname: cat.rewrite,
						url: '/discover?category=' + cat.rewrite,
						featured: !!cat.featured,
						subcategories: cat.subcategories.map((subcat) => {
							return {
								id: subcat.categoryid,
								name: subcat.categorytitle,
								shortname: subcat.rewrite,
								ismeeting: subcat.ismeeting
							}
						})
					}
				})

			const featList = data.filter((i) => i.featured)
			const taList = data.filter((i) => !i.featured)


			output = []

			if (featList.length > 0) {
				output.push({
					title: 'Featured',
					list: featList
				})
			}

			if (taList.length > 0) {
				output.push({
					title: 'Therapeutic Areas',
					list: taList
				})
			}
		}
		else {
			output = []
		}

		return output
	},
	async getBreakingNews({ commit }) {
		await axios.get(process.env.VUE_APP_ARTICLES_URL)
			.then(async ({ data }) => {
				const breaking = data?.sections
					.filter((section) => section.heading === 'Breaking News Articles')[0]
		
				commit('setBreakingNews', breaking || null)
			})
			.catch((err) => { console.log(err) })

	},
	async submitAnalytics({ state }, payload) {
		const defaultData = {
			app_id: '20000',
			appname: location.href,
			apptype: 'breakingmed',
			category: 'poc',
			metavalue: `${ location.href } | BreakingMED`,
			event: null,
			label: null,
			platform: 'web',
			session: null,
			token: state.userToken,
			userAgent: navigator.userAgent,
			value: 1,
		}

		const params = {}
	
		const body = Object.assign(defaultData, payload || {})

		if (body?.token !== '') params.token = body.token
	
		const urlParams = Object
			.keys(params)
			.map((key) => { 
				return key + '=' + params[key]
			})
			.join('&')
			|| null
	
		const url = process.env.VUE_APP_ANALYTICS_URL + (urlParams ? '?' + urlParams : '')

		await axios.post(url, body, {
			headers: {
				'content-type': 'text/json'
			}
		})
			.then(() => { console.log(body) })
			.catch((e) => console.log(e))
	},
	setBaseUrl({ commit }, value) {
		commit('setBaseUrl', value)
	},
	setPageMode({ commit }, value) {
		commit('setPageMode', value)
	},
	setUserToken({ commit }, value) {
		if (value) {
			commit('setUserToken', value)
			commit('setIsAuth', true)
		}
		else {
			commit('setUserToken', null)
			commit('setIsAuth', false)
		}
	},
	setLoginUrl({ commit }, value) {
		commit('setLoginUrl', value)
	},
	setClaimCreditUrl({ commit }, value) {
		commit('setClaimCreditUrl', value)
	},
	showNavMenu({ commit }) {
		commit('setIsNavMenuVisible', true)
	},
	hideNavMenu({ commit }) {
		commit('setIsNavMenuVisible', false)
	},
	showCmeInfoModal({ commit }) {
		commit('setIsCmeInfoModalVisible', true)
	},
	hideCmeInfoModal({ commit }) {
		commit('setIsCmeInfoModalVisible', false)
	},
	showCmeRegModal({ commit }) {
		commit('setIsCmeRegModalVisible', true)
	},
	hideCmeRegModal({ commit }) {
		commit('setIsCmeRegModalVisible', false)
	},
	setLogoutFunction({ commit }, value) {
		commit('setLogoutFunction', value)
	},
	userLogout({ dispatch }) { 
    document.cookie =  "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

		dispatch('setUserToken', null)
	}
}

const getters = {
	baseUrl(state) {
		return state.baseUrl
	},
	isAuth(state) {
		return state.isAuth
	},
	userToken(state) {
		return state.userToken
	},
	loginUrl(state) {
		return state.loginUrl
	},
	claimCreditUrl(state) {
		return state.claimCreditUrl
	},
	isNavMenuVisible(state) {
		return state.isNavMenuVisible
	},
	isCmeInfoModalVisible(state) {
		return state.isCmeInfoModalVisible
	},
	isCmeRegModalVisible(state) {
		return state.isCmeRegModalVisible
	},
	breakingNews(state) {
		return state.breakingNews
	},
	categories(state) {
		return state.categories
	},
}

export default createStore({
	state,
	mutations,
	actions,
	getters
})